import { styled } from '@mui/material';

export const Container = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '1.25rem',
  marginBottom: '1.25rem',
}));

export const ToolbarBox = styled('div')(({ theme }) => ({
  display: 'flex',
  backgroundColor: 'white',
  flexDirection: 'row',
  borderRadius: '0.5rem',
  border: `1px solid ${theme.palette.grey[100]}`,
  padding: '0.5rem',
  alignItems: 'center',
  gap: '1rem',
}));

export const ToolbarButton = styled('div', {
  shouldForwardProp: (propName: string) => propName !== 'disabled',
})<{ disabled?: boolean }>(({ theme, disabled }) => ({
  flex: 0,
  display: 'flex',
  padding: '0.25rem',
  alignItems: 'center',
  gap: '0.5rem',
  borderRadius: '0.25rem',
  color: theme.palette.grey[900],
  backgroundColor: 'white',
  cursor: 'pointer',

  '& > svg > path': {
    fill: disabled ? theme.palette.grey[200] : theme.palette.grey[900],
  },
}));

export const Divider = styled('div')(({ theme }) => ({
  width: '0.0825rem',
  height: '1.125rem',
  backgroundColor: theme.palette.grey[100],
}));

export const ToolbarButtonLabel = styled('p')`
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  margin: 0;

  -ms-user-select: none;
  -webkit-user-select: none;
  user-select: none;
`;
